"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowFinishState = void 0;
var react_1 = __importDefault(require("react"));
var react_components_1 = require("@brightlayer-ui/react-components");
var Box_1 = __importDefault(require("@mui/material/Box"));
/**
 * Component that renders a EmptyState component indicating completion of a user flow.
 *
 * @param props all props will be passed to the EmptyState component, except for style
 * which is applied to the root element
 *
 * @category Component
 */
var WorkflowFinishState = function (props) {
    var _a = props.classes, emptyStateClasses = _a === void 0 ? {} : _a, style = props.style, sx = props.sx, emptyStateProps = __rest(props, ["classes", "style", "sx"]);
    return (react_1.default.createElement(Box_1.default, { sx: __spreadArray([
            {
                display: 'flex',
                flex: '1 1 0%',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                minHeight: { md: 500, sm: 'auto' },
            }
        ], (Array.isArray(sx) ? sx : [sx]), true), style: style },
        react_1.default.createElement(react_components_1.EmptyState, __assign({}, emptyStateProps, { classes: __assign(__assign({}, emptyStateClasses), { description: emptyStateClasses.description }), sx: {
                color: 'inherit',
                p: 0,
            } }))));
};
exports.WorkflowFinishState = WorkflowFinishState;
